export const CARD_TYPE = {
	virtual: 'virtual',
	physical: 'physical',
};
